import { useListPaymentOrdersQuery } from '@/types/generated/graphql';
import { cacheOnly } from '@shared/constants';
import { CONFIRM_PAYMENT_BADGE_VARIABLES } from '../confirm-payment.constants';

export function useConfirmPaymentBadge() {
  const { data } = useListPaymentOrdersQuery({
    variables: CONFIRM_PAYMENT_BADGE_VARIABLES,
    ...cacheOnly,
  });

  const pendingOrders = data?.listPaymentOrders?.data ?? [];

  return {
    count: pendingOrders.length,
    hasPendingOrders: pendingOrders.length > 0,
    firstPendingOrderId: pendingOrders[0]?.id ?? null,
  };
}
